<div class="row col-12">
  <canvas style="background-color: lightyellow"
          #canvas
          (touchstart)="startDrawing($event)"
          (touchmove)="moved($event)"
          width="300"
          height="150"
  >
  </canvas>
  <input [ngClass]="inputboxClass" autocomplete="off" autofocus [(ngModel)]="nameField" (keyup)="drawSignature()"  (keydown)="no_backspaces($event)"  #nameFieldNm="ngModel"   type="text"  name="nameFieldNm" id="nameFieldId">
</div>

<div class="row">
  <div class="col-12 text-center my-1">
    <button class="mx-1" nbButton ghost status="primary" (click)="clearPad()">Clear</button>
  </div>
</div>

